export default __webpack_public_path__ + "static/media/idade-do-talhao.0bb09e39.svg";